var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_290_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 25.9915C20.1797 25.9915 26 20.175 26 13C26 5.82502 20.1797 0.00854492 13 0.00854492C5.8203 0.00854492 0 5.82502 0 13C0 20.175 5.8203 25.9915 13 25.9915Z",
    fill: "#4DAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1113 14.5604L15.6172 15.7281L18.4786 19.3893L19.9728 18.2215L17.1113 14.5604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7076 19.9944L14.846 16.3312C12.248 15.6077 10.4247 13.2758 10.3496 10.5799L7.48797 6.91882C7.48797 6.91882 4.77665 10.803 9.03172 16.2443C13.2868 21.6856 17.7076 19.9944 17.7076 19.9944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75197 5.14801L8.25781 6.3158L11.1192 9.97692L12.6134 8.80913L9.75197 5.14801Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_290_239"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.a20daf5f43491d35741b24b85bae1fb1.svg";
export { ForwardRef as ReactComponent };